import * as ko from 'knockout'
import ObservableScratching from '@classic/Betting-v2/Model/Observables/ObservableScratching'
import template from './scratchings.tpl.html'
import { ScratchingsViewModel } from './ScratchingsViewModel'

interface Params {
  availableScratchings: ko.ObservableArray<ObservableScratching>
}

if (!ko.components.isRegistered('scratchings-panel')) {
  ko.components.register('scratchings-panel', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new ScratchingsViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
